import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

/** Default timezone for all event scheduling (India). */
export const APP_TIMEZONE = "Asia/Kolkata";

dayjs.tz.setDefault(APP_TIMEZONE);

export default dayjs;
